import React from "react"

const TimelineEvent = props => {
  // let [descriptionIsOpen, setDescriptionIsOpen] = useState(
  //   props.descriptionIsOpen
  // )

  return (
    <div className="timeline-event">
      <div className="timeline-event-marker"></div>
      <div className="timeline-event-content fade-in">
        <span className="time">{props.time}</span>
        <h3 className="title">{props.title}</h3>
        <h4 className="location">{props.location}</h4>
        {/* <button>See more...</button> */}
        <p
          className={
            props.className ? "description" : "description text-hidden"
          }
        >
          {props.description}
        </p>
      </div>
    </div>
  )
}

export default TimelineEvent
